export const pageAnimation = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: { duration: 1, when: 'beforeChildren', staggerChildren: 0.25 },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.5 },
  },
};

export const titleAnim = {
  hidden: { y: 200 },
  show: {
    y: 0,
    transition: { duration: 0.75, ease: 'easeOut' },
  },
};

export const fade = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      ease: 'easeOut',
      duration: 0.25,
      staggerChildren: 0.25,
    },
  },
};

export const photoAnim = {
  hidden: { scale: 1.5, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { ease: 'easeOut', duration: 1 } },
};

export const lineAnim = {
  hidden: { width: '0%' },
  show: { width: '100%', transition: { ease: 'easeOut', duration: 0.5 } },
};

export const smallLineAnim = {
  hidden: { width: '0%' },
  show: { width: '70%', transition: { ease: 'easeOut', duration: 2 } },
};

export const slider = {
  hidden: { x: 0 },
  show: { x: '100%', transition: { ease: 'easeOut', duration: 1 } },
};

export const sliderContainer = {
  hidden: { width: '100%' },
  show: {
    width: '100%',
    transition: { ease: 'easeOut', duration: 1, staggerChildren: 0.2 },
  },
};

export const scrollSection = {
  hidden: { scale: 0.5, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
    transition: { ease: 'easeOut', duration: 0.5 },
  },
};
